import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function TenantSchemaManage ( props ) {

    return(
        <BasicCrudScreenType
            id="TenantSchemaManage"
            table="TenantSchemaManage"
            view="VwTenantSchemaManage"
            noExcel
            buttonsInFrontOfSearch
        />
    ) 

}

export default TenantSchemaManage;
